import { VERTICAL_EMBED_TYPE } from 'wix-rich-content-common';
import { hasPlugin as hasPluginInPlugins } from '@wix/ricos-common';
import { verticalEmbedViewerStrategy } from './verticalEmbedViewerStrategy/verticalEmbedViewerStrategy';
export const runViewerStrategies = (plugins, baseUrl, previewMode) => {
    const hasPlugin = (pluginType) => hasPluginInPlugins(pluginType, plugins);
    return baseUrl && hasPlugin(VERTICAL_EMBED_TYPE)
        ? verticalEmbedViewerStrategy(baseUrl, previewMode)
        : { config: {} };
};
//# sourceMappingURL=runViewerStrategies.js.map